import { StudyMaterialGuardianStudentComponent } from './study-material-guardian-student/study-material-guardian-student.component';
import { StudyMaterialCardComponent } from './study-material-card/study-material-card.component';
import { StudyMaterialSyllabusIndexComponent } from './study-material-syllabus-index/study-material-syllabus-index.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [

  { path: "study/material/index/:server_user_id", component: StudyMaterialSyllabusIndexComponent},
  { path: "study/material/card/:server_subtopic_id", component: StudyMaterialCardComponent},
  { path: "study/material/index/:server_user_id/:student_user_id", component: StudyMaterialGuardianStudentComponent}
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  providers:[
  ],
  exports: [RouterModule]
})
export class StudyRoutingModule { }
